import { useLanguage } from "../../LanguageContext";
import FeaturedIndex from "./FeaturedIndex";
import { labFeaturedItems } from "./labItems";
import SectionTitle from "./SectionTitle";

export default function LabSection() {
	const { text, lang } = useLanguage();

	return (
		<section className="home-section" aria-labelledby="lab-title">
			<SectionTitle
				id="lab"
				kicker={text.lab.kicker}
				title={text.lab.title}
				titleId="lab-title"
				action={{ to: "/lab", label: text.lab.allExperiments }}
			/>
			<FeaturedIndex
				layout="cards"
				items={labFeaturedItems(
					text.lab.experiments,
					lang,
					text.lab.openExperiment,
				)}
			/>
		</section>
	);
}
